// extracted by mini-css-extract-plugin
module.exports = {"mention":"Mention__mention___1C2yE"};